const STORAGE_KEY_PREFIX = 'lexio:learning-demo:v2'

function storageKey(userId: string) {
  return `${STORAGE_KEY_PREFIX}:${userId}`
}

export function isLearningDemoCompleted(userId: string): boolean {
  try {
    return localStorage.getItem(storageKey(userId)) === '1'
  } catch {
    return false
  }
}

export function markLearningDemoCompleted(userId: string): void {
  try {
    localStorage.setItem(storageKey(userId), '1')
  } catch {
    // ignore quota / private mode
  }
}

export function clearLearningDemoCompleted(userId: string): void {
  try {
    localStorage.removeItem(storageKey(userId))
  } catch {
    // ignore
  }
}
